// Utility to get or create a unique device ID for this browser
export function getOrCreateDeviceId() {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    if (window.crypto && window.crypto.randomUUID) {
      deviceId = window.crypto.randomUUID();
    } else {
      // Fallback for older browsers
      deviceId = Math.random().toString(36).substr(2, 16) + Date.now();
    }
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
}

// Helper function to get token
export function getToken() {
  return localStorage.getItem("token");
}

// Field display configuration utilities
export const getVisibleFieldsForEmrType = (emrTypeName, fieldDisplayConfig) => {
  return (
    fieldDisplayConfig[emrTypeName] || [
      "Type",
      "Client",
      "Instructions",
      "Created At",
    ]
  );
};

export const renderFieldValue = (session, fieldName, formatDate) => {
  switch (fieldName) {
    case "Type":
      return session.emr_name || "";
    case "Client":
      return session.client_id_name || "";
    case "Instructions":
      return session.manual_instructions || "";
    case "Created At":
      return formatDate ? formatDate(session.created_at) : session.created_at;
    case "Client Id":
    case "client_id":
    case "client id":
      // Special handling for client_id field - show client__id (custom data) instead of client_id (UUID)
      if (
        session.hasOwnProperty("client__id") &&
        session.client__id !== null &&
        session.client__id !== undefined &&
        session.client__id !== ""
      ) {
        return session.client__id;
      } else {
        return ""; // Show empty if no custom data
      }
    default:
      // For dynamic fields, try to find the value in session data
      // Try multiple variations of the field name
      const fieldVariations = [
        fieldName,
        fieldName.toLowerCase().replace(/\s+/g, "_"),
        fieldName.toLowerCase().replace(/\s+/g, ""),
        fieldName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(""),
        fieldName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join("_"),
      ];

      let fieldValue = null;
      for (const variation of fieldVariations) {
        if (
          session.hasOwnProperty(variation) &&
          session[variation] !== null &&
          session[variation] !== undefined
        ) {
          fieldValue = session[variation];
          break;
        }
      }

      // If still not found, try case-insensitive search
      if (fieldValue === null) {
        const sessionKeys = Object.keys(session);
        for (const key of sessionKeys) {
          const normalizedKey = key.toLowerCase().replace(/[^a-z0-9]/g, "");
          const normalizedFieldName = fieldName
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "");
          if (normalizedKey === normalizedFieldName) {
            fieldValue = session[key];
            break;
          }
        }
      }

      // Check if this looks like a datetime field and apply formatting
      if (fieldValue && typeof fieldValue === "string") {
        // Check if it matches datetime pattern (YYYY-MM-DD HH:mm:ss)
        if (fieldValue.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
          return formatDate ? formatDate(fieldValue) : fieldValue;
        }
      }

      return fieldValue || "";
  }
};

export const getFieldIcon = (fieldName) => {
  switch (fieldName) {
    case "Type":
      return "DocumentTextIcon";
    case "Client":
      return "UserIcon";
    case "Instructions":
      return "DocumentTextIcon";
    case "Created At":
      return "CalendarIcon";
    default:
      return "DocumentTextIcon";
  }
};

export const formatFieldName = (fieldName) => {
  return fieldName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
